module.exports = __webpack_public_path__ + "static/media/hero1.bfa13d29.jpg";